/* Hovering/focusing a color swatch previews that colorway's image on the product card. */
(function () {
  if (window.__cardSwatchesInit) return;
  window.__cardSwatchesInit = true;

  function getImage(swatch) {
    var wrapper = swatch.closest('.card-wrapper');
    if (!wrapper) return null;
    return { wrapper: wrapper, img: wrapper.querySelector('.card__media .media > img') };
  }

  function preview(swatch) {
    var url = swatch.getAttribute('data-card-swatch-image');
    var target = getImage(swatch);
    if (!url || !target || !target.img) return;
    var img = target.img;
    if (img.dataset.swatchOrigSrc === undefined) {
      img.dataset.swatchOrigSrc = img.getAttribute('src') || '';
      img.dataset.swatchOrigSrcset = img.getAttribute('srcset') || '';
    }
    img.removeAttribute('srcset');
    img.setAttribute('src', url);
    target.wrapper.classList.add('is-swatch-preview');
  }

  function restore(swatch) {
    var target = getImage(swatch);
    if (!target || !target.img) return;
    var img = target.img;
    if (img.dataset.swatchOrigSrc !== undefined) {
      img.setAttribute('src', img.dataset.swatchOrigSrc);
      if (img.dataset.swatchOrigSrcset) img.setAttribute('srcset', img.dataset.swatchOrigSrcset);
      delete img.dataset.swatchOrigSrc;
      delete img.dataset.swatchOrigSrcset;
    }
    target.wrapper.classList.remove('is-swatch-preview');
  }

  function find(e) {
    return e.target && e.target.closest ? e.target.closest('.card-swatch[data-card-swatch-image]') : null;
  }

  /* Product page: show the colour name next to "Color" (current one, or the hovered one) */
  function setName(container, swatch) {
    var out = container && container.querySelector('[data-card-swatch-name]');
    if (!out) return;
    out.textContent = swatch && swatch.title ? ': ' + swatch.title : '';
  }
  function currentOf(container) {
    return container.querySelector('.card-swatch.is-current');
  }
  function initNames() {
    document.querySelectorAll('.card-swatches--product').forEach(function (c) {
      setName(c, currentOf(c));
    });
  }
  initNames();
  document.addEventListener('shopify:section:load', initNames);
  document.addEventListener('mouseover', function (e) {
    var s = e.target.closest && e.target.closest('.card-swatches--product .card-swatch');
    if (s) setName(s.closest('.card-swatches--product'), s);
  });
  document.addEventListener('mouseout', function (e) {
    var c = e.target.closest && e.target.closest('.card-swatches--product');
    if (c && !c.contains(e.relatedTarget)) setName(c, currentOf(c));
  });

  document.addEventListener('mouseover', function (e) {
    var s = find(e);
    if (s) preview(s);
  });
  document.addEventListener('mouseout', function (e) {
    var s = find(e);
    if (s && !s.contains(e.relatedTarget)) restore(s);
  });
  document.addEventListener('focusin', function (e) {
    var s = find(e);
    if (s) preview(s);
  });
  document.addEventListener('focusout', function (e) {
    var s = find(e);
    if (s) restore(s);
  });
})();
